import { render, staticRenderFns } from "./MessageDistributionListDetail.vue?vue&type=template&id=32a3854e"
import script from "./MessageDistributionListDetail.vue?vue&type=script&lang=js"
export * from "./MessageDistributionListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports